/* eslint-disable */

import React from 'react'
import { Column } from 'react-virtualized'
import { getYearMonthDateFormat } from 'common/dateUtils'
import Table from '../../../containers/Tables/Crpcomponents/Table'
import TableStyles from '../../../containers/Tables/Crpcomponents/Table/Table.css'
import TableHeader from '../../../containers/Tables/Crpcomponents/TableHeader'
import TableActions from '../../../containers/Tables/Crpcomponents/TableActions'
import TableActionStyles from '../../../containers/Tables/Crpcomponents/TableActions/TableActions.css'
import { SearchPopover } from '../../../containers/Popovers'
import styles from './TeamInvitesTable.css'
import CancelIcon from 'static/images/cancel.svg'
import { TEAM_INVITES_TABLE_COLUMN_HEADERS, TABLE_CHECKBOX_WIDTH, TABLE_BULK_ACTIONS } from '../../../constants'
import Loading from '../../../components/Loading'
import { getSelectedList } from '../../../containers/Tables/Utilities'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled} from 'configs'
import { FormattedMessage } from 'react-intl'

class TeamInvitesTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {},
      option:null,
    }
  }

  static getDerivedStateFromProps(props, s) {
    const state = s

    if (state.selected !== props.selected) {
      state.selected = props.selected
    }

    return state
  }

  handleOnSelectionClick = selected => {
    const {
      onSelectionClick,
    } = this.props

    this.setState({
      selected,
    })

    if (onSelectionClick) {
      onSelectionClick(selected)
    }
  }

  render() {
    const {
      noDataText = <FormattedMessage id="notfound.pending_invites" />,
      enableLoader,
      showLoader,
      showRowSelection = false,
      data,
      width,
      onRowClick,
      sortBy,
      sortDirection,
      rowHeight = 50,

      filterEmail,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnOutsidePopoverClick,
      handleOnBulkAction,
      handleOnBulkActionClearSelection,
      handleOnPopoverKeyUp,
      bulkActionComplete,
      bulkActionIsFetching,
      selectedPopover,
      me,
      selectedEmail,
    } = this.props
    const {
      selected,
    } = this.state

    const isAnySelected = Object.keys(selected).some(key => selected[key] === true)

    let emailWidth = width
    let emailPopoverClassname = styles.emailPopover

    if (showRowSelection) {
      emailWidth -= TABLE_CHECKBOX_WIDTH
      emailPopoverClassname = styles.emailPopoverWithSelection
    }

    const numberOfSelection = getSelectedList(selected).length
    const tkEnabled = checkTKFeatureEnabled(me)
    const crpEnabled = checkCRPFeatureEnabled(me)
    const firstNameWidth = 251
    const lastNameWidth = 250
    const dateWidth = 300
    const emailsWidth = 300
  
    return (
      <div className={styles.teamInvitesTable}>
        {( (crpEnabled || tkEnabled) &&
          <Table
            noDataText={noDataText}
            enableLoader={enableLoader}
            showLoader={showLoader}
            // headerHeight={35}
            showRowSelection={showRowSelection}
            disableRowSelection={bulkActionComplete || bulkActionIsFetching}
            selected={selected}
            rowHeight={rowHeight}
            uniqueKey="id"
            hasTableActions={isAnySelected}
            onSelectionClick={this.handleOnSelectionClick}
            onRowClick={onRowClick}
            data={data}
            sortBy={sortBy}
            sortDirection={sortDirection}
          >
            <Column
              className={TableStyles.column}
              label={<FormattedMessage id="label.first_name" />}
              dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.FIRSTNAME}
              width={firstNameWidth}
              headerRenderer={headerProps => {
                const {
                  label,
                } = headerProps

                return (
                  <TableHeader
                    label={label}
                    columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.FIRSTNAME}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    handleOnSortClick={handleOnSortClick}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                  />
                )
              }}
              cellRenderer={({ dataKey, rowData }) => (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={TableStyles.primaryText}>
                    {rowData[dataKey]}
                  </p>
                </div>
              )}
            />
            <Column
              className={TableStyles.column}
              label={<FormattedMessage id="label.last_name" />}
              dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.LASTNAME}
              width={lastNameWidth}
              headerRenderer={headerProps => {
                const {
                  label,
                } = headerProps

                return (
                  <TableHeader
                    label={label}
                    columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.LASTNAME}
                    handleOnSortClick={handleOnSortClick}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                  />
                )
              }}
              cellRenderer={({ dataKey, rowData }) => (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={TableStyles.primaryText}>
                    {rowData[dataKey]}
                  </p>
                </div>
              )}
            />
            <Column
              className={TableStyles.column}
              label={<FormattedMessage id="label.email" />}
              dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
              width={emailsWidth}
              headerRenderer={headerProps => {
                const {
                  label,
                } = headerProps

                return (
                  <TableHeader
                    label={label}
                    columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
                    handleOnSortClick={handleOnSortClick}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    filterActive={filterEmail}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                  />
                )
              }}
              cellRenderer={({ dataKey, rowData }) => (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={TableStyles.primaryText}>
                    {rowData[dataKey]}
                  </p>
                </div>
              )}
            />
            <Column
              className={TableStyles.column}
              label={<FormattedMessage id="label.Date_Sent" />}
              dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.DATE}
              width={dateWidth}
              headerRenderer={headerProps => {
                const {
                  label,
                } = headerProps

                return (
                  <TableHeader
                    label={label}
                    columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.DATE}
                    handleOnSortClick={handleOnSortClick}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                  />
                )
              }}
              cellRenderer={({ dataKey, rowData }) => (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={TableStyles.primaryText}>
                    {getYearMonthDateFormat(rowData[dataKey], me)}
                  </p>
                </div>
              )}
            />
          </Table>
          )}
         {( (!crpEnabled && !tkEnabled) &&
          <Table
                noDataText={noDataText}
                enableLoader={enableLoader}
                showLoader={showLoader}
                // headerHeight={35}
                showRowSelection={showRowSelection}
                disableRowSelection={bulkActionComplete || bulkActionIsFetching}
                selected={selected}
                rowHeight={rowHeight}
                uniqueKey="id"
                hasTableActions={isAnySelected}
                onSelectionClick={this.handleOnSelectionClick}
                onRowClick={onRowClick}
                data={data}
                sortBy={sortBy}
                sortDirection={sortDirection}
                type={!crpEnabled && !tkEnabled}
              >
                <Column
                  className={TableStyles.column}
                  label={<FormattedMessage id="label.email" />}
                  dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
                  width={emailWidth}
                  headerRenderer={headerProps => {
                    const {
                      label,
                    } = headerProps
      
                    return (
                      <TableHeader
                        label={label}
                        columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
                        handleOnSortClick={handleOnSortClick}
                        handleOnFilterButtonClick={handleOnFilterButtonClick}
                        filterActive={filterEmail}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        // selectedPopover={selectedPopover}
                        // Popover={(
                        //   <div className={emailPopoverClassname}>
                        //     {/* <SearchPopover
                        //       handleOnPopoverKeyUp={handleOnPopoverKeyUp}
                        //       handleOnChange={email => handleOnFilterChange(TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL, email)}
                        //       handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        //       value={selectedEmail}
                        //       placeholder="Email..."
                        //     /> */}
                        //   </div>
                        // )}
                      />
                    )
                  }}
                  cellRenderer={({ dataKey, rowData }) => (
                    <div className={TableStyles.centeredColumnContent}>
                      <p className={TableStyles.primaryText}>
                        {rowData[dataKey]}
                      </p>
                    </div>
                  )}
                />
                <Column
                  className={TableStyles.column}
                  label={<FormattedMessage id="label.Date_Sent" />}
                  dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.DATE}
                  width={emailWidth}
                  headerRenderer={headerProps => {
                    const {
                      label,
                    } = headerProps
      
                    return (
                      <TableHeader
                        label={label}
                        columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.DATE}
                        handleOnSortClick={handleOnSortClick}
                        handleOnFilterButtonClick={handleOnFilterButtonClick}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        // selectedPopover={selectedPopover}
                        // Popover={(
                        //   <div className={emailPopoverClassname}>
                        //     {/* <SearchPopover
                        //       handleOnPopoverKeyUp={handleOnPopoverKeyUp}
                        //       handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        //       placeholder=""
                        //     /> */}
                        //   </div>
                        // )}
                      />
                    )
                  }}
                  cellRenderer={({ dataKey, rowData }) => (
                    <div className={TableStyles.centeredColumnContent}>
                      <p className={TableStyles.primaryText}>
                        {getYearMonthDateFormat(rowData[dataKey], me)}
                      </p>
                    </div>
                  )}
                />
          </Table>
        )}
        <TableActions
          selected={selected}
          visible={isAnySelected}
          clearSelection={handleOnBulkActionClearSelection}
          bulkActionComplete={bulkActionComplete}
          bulkActionIsFetching={bulkActionIsFetching}
          // eventually when there is more than 1 option, this will need to become a system to support which bulk
          // action was taken and show the cooresponding success or failure message
          successMessage={<FormattedMessage id={`information.invitation_${this.state.option}`} values={{
            numberOfSelection
          }}/>
          }
        >
          {bulkActionIsFetching
            ? (
              <button disabled className={TableActionStyles.submitLoading}>
                <Loading />
              </button>
            )
            : (
            <div className={TableActionStyles.actionButtons}>
              <div>
              <button
                className={TableActionStyles.actionButton}
                onClick={() => {handleOnBulkAction(TABLE_BULK_ACTIONS.REVOKE_FROM_TEAM),this.setState({option:'revoked'})}}
              >
                <CancelIcon className={styles.cancelIcon} />
                <span><FormattedMessage id="button.revoke" /></span>
              </button>
              </div>
              <div style ={{ marginLeft : '15px'}}>
              <button
              className={TableActionStyles.resend}
              onClick={() =>{handleOnBulkAction(TABLE_BULK_ACTIONS.RESEND_FROM_TEAM),this.setState({option:'resend'})}}
               >
              <span><FormattedMessage id="button.resend_invite" /></span>
            </button>
            </div>
            </div>
            )
          }
        </TableActions>
      </div>
    )
  }
}

export default TeamInvitesTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamInvitesTable/TeamInvitesTable.jsx